import React, { useEffect } from 'react';
import { initPixel } from './lib/pixel';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { PainPoints } from './components/PainPoints';
import { ProductIntro } from './components/ProductIntro';
import { TomosGrid } from './components/TomosGrid';
import { BonusGrid } from './components/BonusGrid';
import { CountdownScarcity } from './components/CountdownScarcity';
import { PricingCards } from './components/PricingCards';
import { EliteExplainer } from './components/EliteExplainer';
import { TestimonialsFull } from './components/TestimonialsFull';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostOfInaction } from './components/CostOfInaction';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { FloatingProof } from './components/FloatingProof';
export function App() {
  useEffect(() => {
    // Defer pixel init until after page is fully interactive
    // so any pixel/CORS issue can't break first paint.
    const id = window.requestIdleCallback ? window.requestIdleCallback(() => initPixel()) : window.setTimeout(() => initPixel(), 1500);
    return () => {
      if (window.cancelIdleCallback && typeof id === 'number') {
        try {
          window.cancelIdleCallback(id as any);
        } catch {}
      } else if (typeof id === 'number') {
        clearTimeout(id);
      }
    };
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-gold selection:text-deep-green" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <SocialProofBar data-id="element-3" />
        <PainPoints data-id="element-4" />
        <ProductIntro data-id="element-5" />
        <TomosGrid data-id="element-6" />
        <BonusGrid data-id="element-7" />
        <CountdownScarcity data-id="element-8" />
        <PricingCards data-id="element-9" />
        <EliteExplainer data-id="element-10" />
        <TestimonialsFull data-id="element-11" />
        <Guarantee data-id="element-12" />
        <FAQ data-id="element-13" />
        <CostOfInaction data-id="element-14" />
        <FinalCTA data-id="element-15" />
      </main>
      <Footer data-id="element-16" />

      {/* Floating Elements */}
      <FloatingProof data-id="element-17" />
    </div>;
}